import React, { useImperativeHandle, useEffect } from 'react';
import { useNECaptcha } from '@yaotai/common-utils';

React.forwardRef(({ value, onChange, id }, ref) => {
    const { validate, captchaIns } = useNECaptcha({ element: `#${id || 'captcha-register'}` });
    useImperativeHandle(ref, () => {
        return {
            captchaIns,
        };
    });
    useEffect(() => {
        validate !== undefined && onChange?.(validate);
    }, [validate]);
    return React.createElement("div", { id: id || 'captcha-register' });
});
